import superstyled from '@zenbusiness/zui/styles/superstyled';

import Field from '#client/components/Field';

export const AccountFieldsetField = superstyled({
  name: 'AccountFieldset',
  slot: 'Field',
  tag: Field,
  styles: ({ theme, variant }) => ({
    ...(variant === 'standard' && {
      '&[readonly] .MuiInputBase-root': {
        borderColor: 'transparent'
      },

      '&[readonly] .MuiInputBase-input': {
        ...theme.typography.sm,
        position: 'relative',
        top: theme.spacing(0.25)
      },

      '&[readonly] .MuiInputLabel-root': {
        ...theme.typography.sm,
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightMedium
      }
    })
  })
});
